import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as appDataActions from '../actions/appDataActions';
import * as trackingDataActions from '../actions/trackingDataActions';
import * as appHelper from '../helpers/appHelper';
import {getMenuComponentByType} from '../helpers/componentHelper';

class AppBiteMenu extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            menu_type:{}
        };

        this.getMenuType = this.getMenuType.bind(this);
    }
    componentDidMount(){
        this.getMenuType();
        this.props.actions.setFooterNavigationVisibility(false);
    }

    componentWillReceiveProps(nextProps) {

    }

    getMenuType(){

        if(appHelper.isDefined(this.props.contentData.experience)){
            let menu_type = Object.assign({},getMenuComponentByType(this.props.contentData.experience.experience_learning_model));
            this.setState({menu_type: Object.assign({},menu_type), render: false});
        }
        this.props.actions.clearAudio();
        //let biteType = Object.assign({},getBiteComponentByType(this.state.bite.bite_type));
        //this.setState({bite_type: Object.assign({},biteType), render: false});
    }

    render() {

        return (
            <div className="app-bite" >
                {
                    typeof this.state.menu_type.component !== 'undefined'
                        ?<this.state.menu_type.component />
                        :null
                }
            </div>
        );
    }
}

AppBiteMenu.propTypes = {
    contentData: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired
};

AppBiteMenu.contextTypes = {
    router: PropTypes.object
};

function mapStateToProps(state) {
    return {
        contentData: state.contentData,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign({}, appDataActions, trackingDataActions), dispatch)
    };
}
export default connect(mapStateToProps,mapDispatchToProps)(AppBiteMenu);



/** WEBPACK FOOTER **
 ** ./src/components/AppBiteMenu.js
 **/